"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Mail, MapPin, MessageCircle, Phone, Twitter, Youtube } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300">Início</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors duration-300">Blog Winlife</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function IronCommunityFooter() {
  const shopLinks = [{
    title: "Loja Completa",
    path: "/ShopPage"
  }, {
    title: "Revendedores",
    path: "/ResellersPage"
  }, {
    title: "Sobre a Winlife",
    path: "/AboutWinlifePage"
  }, {
    title: "Blog e Saúde",
    path: "/BlogPage"
  }];
  const socialLinks = [{
    icon: Instagram,
    label: "Instagram",
    href: "#"
  }, {
    icon: Twitter,
    label: "Twitter",
    href: "#"
  }, {
    icon: Facebook,
    label: "Facebook",
    href: "#"
  }, {
    icon: Youtube,
    label: "YouTube",
    href: "#"
  }];
  return <section data-section-id="203234" id="rodapé-institucional" className="dark bg-background text-foreground relative overflow-hidden pt-24 pb-8 border-t border-border">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[150%] sm:w-[120%] md:w-full flex justify-center items-start pt-8 pointer-events-none opacity-[0.03] select-none z-0">
        <WvcLogo className="w-full h-auto max-w-none" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          
          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-wider uppercase mb-6 text-foreground">
              Navegação
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((link, i) => <li key={link.title} data-index={i}>
                  <Link to={link.path} className="text-muted-foreground hover:text-primary transition-colors duration-300">
                    {link.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-wider uppercase mb-6 text-foreground">
              Atendimento
            </h3>
            <ul className="space-y-4 text-muted-foreground">
              <li className="flex items-start gap-3 group">
                <MapPin className="w-5 h-5 shrink-0 text-primary mt-0.5" />
                <span className="group-hover:text-foreground transition-colors duration-300 font-default">
                  Eixo Industrial Eixo Principal, 1592, Parque Industrial (ou Parque Agro-Industrial), Gurupi - TO, CEP 77445-590
                </span>
              </li>
              <li className="flex items-center gap-3 group">
                <Phone className="w-5 h-5 shrink-0 text-primary" />
                <span className="group-hover:text-foreground transition-colors duration-300 font-default">
                  (11) 3042-1282
                </span>
              </li>
              <li className="flex items-center gap-3 group">
                <Mail className="w-5 h-5 shrink-0 text-primary" />
                <span className="group-hover:text-foreground transition-colors duration-300 font-default">
                  contato@winlife.com.br
                </span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-wider uppercase mb-6 text-foreground">
              Institucional
            </h3>
            <MenuProvider menu_id="54">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold tracking-wider uppercase mb-6 text-foreground">
              Conecte-se
            </h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <div key={social.label} data-index={i}>
                    <Link to={social.href} className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary hover:bg-primary/10 transition-all duration-300" aria-label={social.label}>
                      <Icon className="w-4 h-4" />
                    </Link>
                  </div>;
            })}
            </div>
            <p className="mt-6 text-sm text-muted-foreground font-default">
              Assine nossa newsletter para receber dicas de saúde, bem-estar e ofertas exclusivas Winlife.
            </p>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-mono text-muted-foreground uppercase tracking-wider">
            &copy; {new Date().getFullYear()} Winlife Suplementos. Todos os direitos reservados.
          </p>
          <div className="flex gap-6 text-xs font-mono text-muted-foreground uppercase tracking-wider">
            <Link to="#" className="hover:text-primary transition-colors duration-300">Privacidade</Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">Termos de Uso</Link>
          </div>
        </div>
      </div>

      <Button asChild className="fixed bottom-6 right-6 z-50 rounded-full w-14 h-14 bg-primary hover:bg-primary/90 shadow-xl flex items-center justify-center p-0 transition-all duration-300 hover:scale-110 active:scale-95">
        <Link to="https://wa.me/551130421282" newTab aria-label="Fale conosco no WhatsApp">
          <MessageCircle className="w-7 h-7 text-primary-foreground" />
        </Link>
      </Button>
    </section>;
}